import { localFormat } from '@lmt/unicorn-shared/app/helpers/date-helper';
import {
  addDays,
  endOfMonth,
  startOfMonth,
  startOfWeek,
  endOfWeek,
} from 'date-fns';
import { CalendarType, DayOfWeek } from '@lmt/shared-types';

function getEndDate(
  date: Date,
  calendarType: CalendarType,
  options: { firstDayOfWeekIndex: DayOfWeek },
) {
  switch (calendarType) {
    case CalendarType.Day:
      return date;
    case CalendarType.Week:
      return endOfWeek(date, { weekStartsOn: options?.firstDayOfWeekIndex });
    case CalendarType.Month:
      return endOfMonth(date);
    default:
      return date;
  }
}

function getStartDate(
  date: Date,
  calendarType: CalendarType,
  options: { firstDayOfWeekIndex: DayOfWeek },
) {
  switch (calendarType) {
    case CalendarType.Day:
      return date;
    case CalendarType.Week:
      return startOfWeek(date, { weekStartsOn: options?.firstDayOfWeekIndex });
    case CalendarType.Month:
      return startOfMonth(date);
    default:
      return date;
  }
}

export function getWeeksOfMonth(
  date: Date,
  calendarType: CalendarType,
  firstDayOfWeekIndex: DayOfWeek,
): number[][] {
  const endDayOfMonth = endOfMonth(date);
  const startDate = getStartDate(date, calendarType, {
    firstDayOfWeekIndex,
  });
  const endDate = getEndDate(date, calendarType, {
    firstDayOfWeekIndex,
  });
  const startOfMiniCalendar = startOfWeek(startOfMonth(startDate), {
    weekStartsOn: firstDayOfWeekIndex,
  });
  const firstDateOfMonth = startOfMonth(date);

  const weeks = [];
  let currentDate = addDays(startOfMiniCalendar, -1);
  for (let i = 0; i < 6; i++) {
    const days = [];
    for (let j = 0; j <= 6; j++) {
      currentDate = addDays(currentDate, 1);

      if (currentDate < firstDateOfMonth) {
        continue;
      }
      if (currentDate > endDayOfMonth && currentDate > endDate) {
        continue;
      }

      days.push(currentDate.getDate());
    }
    weeks.push(days);
  }
  return weeks;
}

export function getWeekDays(firstDayOfWeekIndex: DayOfWeek): string[] {
  const firstDOW = startOfWeek(new Date(), {
    weekStartsOn: firstDayOfWeekIndex,
  });
  return [...Array(7).keys()].map((i) =>
    localFormat(addDays(firstDOW, i), 'EEEEEE'),
  );
}
